@if (grundstueckEntry) {
  <cap-grundstueck-kopf-icp [grundstueckEntry]="grundstueckEntry" [isEigentuemer]="isEigentuemer"></cap-grundstueck-kopf-icp>
} @else {
  <cap-spinner-small></cap-spinner-small>
}

@if (showRubrik(rubrik.FLAECHE)) {
  <cap-grundstueckflaeche-icp
    [flaechenMaessigNichtAusgeschieden]="grundstueckEntry?.flaechenMaessigNichtAusgeschieden"
    [grundstueckId]="gsId"
    class="my-1">
  </cap-grundstueckflaeche-icp>
}

@if (showRubrik(rubrik.PLAENE)) {
  <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "Grundbuchpläne" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      @if (!plaeneErrored) {
        <cap-grundbuchplaene-table [hasRight]="true" [listLoader]="plaeneListLoader"></cap-grundbuchplaene-table>
      } @else {
        <div class="mt-3">
          <cap-bsg-alert [type]="'warning'">
            {{ "ErrorWhileLoading" | translate }}
          </cap-bsg-alert>
        </div>
      }
    </ng-container>
  </cap-beschreibung-table-wrapper>
}

@if (showRubrik(rubrik.FLURNAME)) {
  <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "Lagebezeichnung" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      @if (!lagebezeichnungErrored) {
        <cap-lagebezeichnung-table [hasRight]="true" [listLoader]="lagebezeichnungListLoader"></cap-lagebezeichnung-table>
      } @else {
        <div class="mt-3">
          <cap-bsg-alert [type]="'warning'">
            {{ "ErrorWhileLoading" | translate }}
          </cap-bsg-alert>
        </div>
      }
    </ng-container>
  </cap-beschreibung-table-wrapper>
}

@if (showRubrik(rubrik.BODENBEDECKUNG)) {
  <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "Bodenbedeckung" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      @if (!bodenbedeckungErrored) {
        <cap-bodenbedeckung-table [listLoader]="bodenbedeckungListLoader"></cap-bodenbedeckung-table>
      } @else {
        <div class="mt-3">
          <cap-bsg-alert [type]="'warning'">
            {{ "ErrorWhileLoading" | translate }}
          </cap-bsg-alert>
        </div>
      }
    </ng-container>
  </cap-beschreibung-table-wrapper>
}

@if (showRubrik(rubrik.GEBAEUDE)) {
  <cap-gebaeude-icp [grundstueckId]="gsId" [navigateTo]="navTargetGrundstuecke" class="my-2"></cap-gebaeude-icp>
}

@if (showRubrik(rubrik.FLAECHENANTEIL)) {
  <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "Flaechenanteile" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      @if (!flaechenAnteileErrored) {
        <cap-flaechenanteil-table
          [grundstueckId]="gsId"
          [listLoader]="flaechenanteileListLoader"
          [navigateTo]="navTargetGrundstuecke"
          [showFlaeche]="false">
        </cap-flaechenanteil-table>
      } @else {
        <div class="mt-3">
          <cap-bsg-alert [type]="'warning'">
            {{ "ErrorWhileLoading" | translate }}
          </cap-bsg-alert>
        </div>
      }
    </ng-container>
  </cap-beschreibung-table-wrapper>
}

@if (showRubrik(rubrik.STAMMGRUNDSTUECK)) {
  <cap-stammgrundstueck-icp [grundstueckId]="gsId" class="my-1"></cap-stammgrundstueck-icp>
}

@if (showRubrik(rubrik.KUHRECHTE)) {
  <cap-kuhrecht [grundstueckId]="gsId" [hasRight]="true" [tableFullWidth]="false" class="my-2"></cap-kuhrecht>
}

@if (grundstueckEntry !== undefined && grundstueckEntry.grundstueckArt === "FOLIO") {
  <cap-alpgrundstuecke
    [anzeigenHistorischeDaten]="false"
    [grundstueckId]="gsId"
    [hasRight]="grundstueckEntry.permissions?.beschreibung"
    [navTargetGrundstuecke]="navTargetGrundstuecke">
  </cap-alpgrundstuecke>
}

@if (showRubrik(rubrik.DOMINIERTE_GRUNDSTUECKE)) {
  <cap-dominierte-grundstuecke-icp [grundstueckId]="gsId" [navigateTo]="navTargetGrundstuecke" class="my-2">
  </cap-dominierte-grundstuecke-icp>
}

<cap-grundstueck-bemerkung [grundstueckId]="gsId" [hasRight]="true" class="my-2"></cap-grundstueck-bemerkung>

@if (showRubrik(rubrik.AV_ANMERKUNGEN)) {
  <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "AnmerkungAmtlicheVermessung" | translate }}
    </span>
    <ng-container class="cap-table-wrapper-content">
      @if (!bemerkungenErrored) {
        <cap-avbemerkung-table-icp [listLoader]="bemerkungListLoader"></cap-avbemerkung-table-icp>
      } @else {
        <div class="mt-3">
          <cap-bsg-alert [type]="'warning'">
            {{ "ErrorWhileLoading" | translate }}
          </cap-bsg-alert>
        </div>
      }
    </ng-container>
  </cap-beschreibung-table-wrapper>
}

@if ((parameterAnzeigeStandardrecht && showRubrik(rubrik.SDR) && hasLoggedInUser) || isEigentuemer) {
  <cap-beschreibung-table-wrapper [tableFullWidth]="false" class="my-2">
    <span class="cap-table-wrapper-title" style="font-weight: bold">
      {{ "SelbststaendigUndDauerndeRechte" | translate }}
    </span>
    @if (!sdrErrored) {
      <cap-standardrecht-table-icp
        [isEigentuemer]="isEigentuemer"
        [listLoader]="sdrDienstbarkeitLoader"
        [showRechtsgrund]="false"
        class="cap-table-wrapper-content">
      </cap-standardrecht-table-icp>
    } @else {
      <div class="mt-3">
        <cap-bsg-alert [type]="'warning'">
          {{ "ErrorWhileLoading" | translate }}
        </cap-bsg-alert>
      </div>
    }
  </cap-beschreibung-table-wrapper>
}

@if (showRubrik(rubrik.SONDERRECHT)) {
  <cap-sonderrecht-icp [grundstueckId]="gsId" [isEigentuemer]="isEigentuemer" class="my-2"></cap-sonderrecht-icp>
}

<cap-rubrik [isClosable]="false" [isOpen]="true">
  <ng-container title>
    <h3>{{ "Eigentum" | translate }}</h3>
  </ng-container>
  <ng-container class="cap-table-wrapper-content">
    @if (!eigentumErrored) {
      <cap-eigentum-table-icp
        [belegHeader]="isEigentuemer ? 'DatumOderBelegOderRechtsgrund' : 'DatumEntstehung'"
        [isEigentuemer]="isEigentuemer"
        [listLoader]="eigentumListLoader"
        [navigateToGrundstueck]="navTargetGrundstuecke"
        [showAdressen]="mitAdressen"
        [verknuepfteEigentuemerIds]="verknuepfteEigentuemerIds">
      </cap-eigentum-table-icp>
    } @else {
      <div class="mt-3">
        <cap-bsg-alert [type]="'warning'">
          {{ "ErrorWhileLoading" | translate }}
        </cap-bsg-alert>
      </div>
    }
  </ng-container>
</cap-rubrik>

@if ((parameterAnzeigeStandardrecht && hasLoggedInUser) || isEigentuemer) {
  <cap-rubrik [isClosable]="false" [isOpen]="true">
    <ng-container title>
      <h3>{{ "grundstueck.rubrik.Dienstbarkeiten" | translate }}</h3>
    </ng-container>
    <ng-container class="cap-table-wrapper-content">
      @if (!dienstbarkeitenErrored) {
        <cap-standardrecht-table-icp [isEigentuemer]="isEigentuemer" [listLoader]="dienstbarkeitenListLoader" [showRechtsgrund]="true">
        </cap-standardrecht-table-icp>
      } @else {
        <div class="mt-3">
          <cap-bsg-alert [type]="'warning'">
            {{ "ErrorWhileLoading" | translate }}
          </cap-bsg-alert>
        </div>
      }
    </ng-container>
  </cap-rubrik>
}

@if ((parameterAnzeigeStandardrecht && hasLoggedInUser) || isEigentuemer) {
  <cap-rubrik [isClosable]="false" [isOpen]="true">
    <ng-container title>
      <h3>{{ "grundstueck.rubrik.Grundlasten" | translate }}</h3>
    </ng-container>
    <ng-container class="cap-table-wrapper-content">
      @if (!grundlastenErrored) {
        <cap-standardrecht-table-icp
          [hasRight]="grundstueckEntry?.permissions?.grundlasten && ersterfassungUebergeben"
          [isEigentuemer]="isEigentuemer"
          [listLoader]="grundlastenListLoader"
          [showRechtsgrund]="true">
        </cap-standardrecht-table-icp>
      } @else {
        <div class="mt-3">
          <cap-bsg-alert [type]="'warning'">
            {{ "ErrorWhileLoading" | translate }}
          </cap-bsg-alert>
        </div>
      }
    </ng-container>
  </cap-rubrik>
}

@if ((parameterAnzeigeStandardrecht && hasLoggedInUser) || isEigentuemer) {
  <cap-rubrik [isClosable]="false" [isOpen]="true">
    <ng-container title>
      <h3>
        {{ isEigentuemer ? ("grundstueck.rubrik.Anmerkungen" | translate) : ("grundstueck.rubrik.OeffentlicheAnmerkungen" | translate) }}
      </h3>
    </ng-container>
    <ng-container class="cap-table-wrapper-content">
      @if (!anmerkungenErrored) {
        <cap-standardrecht-table-icp
          [isEigentuemer]="isEigentuemer"
          [listLoader]="anmerkungenListLoader"
          [rechtArt]="rechtArt.ANMERKUNG"
          [showRechtsgrund]="true">
        </cap-standardrecht-table-icp>
      } @else {
        <div class="mt-3">
          <cap-bsg-alert [type]="'warning'">
            {{ "ErrorWhileLoading" | translate }}
          </cap-bsg-alert>
        </div>
      }
    </ng-container>
  </cap-rubrik>
}

@if (hasLoggedInUser && isEigentuemer) {
  <cap-rubrik [isClosable]="false" [isOpen]="true">
    <ng-container title>
      <h3>{{ "grundstueck.rubrik.Vormerkungen" | translate }}</h3>
    </ng-container>
    @if (!vormerkungenErrored) {
      <cap-standardrecht-table-icp
        [isEigentuemer]="isEigentuemer"
        [listLoader]="vormerkungenListLoader"
        [rechtArt]="rechtArt.VORMERKUNG"
        [showRechtsgrund]="showRechtsgrund">
      </cap-standardrecht-table-icp>
    } @else {
      <div class="mt-3">
        <cap-bsg-alert [type]="'warning'">
          {{ "ErrorWhileLoading" | translate }}
        </cap-bsg-alert>
      </div>
    }
  </cap-rubrik>
}

@if (hasLoggedInUser && isEigentuemer) {
  <cap-rubrik [isClosable]="false" [isOpen]="true">
    <ng-container title>
      <h3>{{ "grundstueck.rubrik.Grundpfandrechte" | translate }}</h3>
    </ng-container>
    <cap-grundpfandrecht-table-icp
      [hasRight]="isEigentuemer && ersterfassungUebergeben"
      [isEigentuemer]="isEigentuemer"
      [listLoader]="pfandrechteListLoader">
    </cap-grundpfandrecht-table-icp>
  </cap-rubrik>
}

@if (hasLoggedInUser && isEigentuemer) {
  <cap-rubrik [isClosable]="false" [isOpen]="true">
    <ng-container title>
      <h3>{{ "grundstueck.rubrik.Rangregelung" | translate }}</h3>
    </ng-container>
    <cap-rangregelung-table-icp [hasRight]="isEigentuemer" [isEigentuemer]="isEigentuemer" [listLoader]="rangregelungenListLoader">
    </cap-rangregelung-table-icp>
  </cap-rubrik>
}

@if (hasLoggedInUser && isEigentuemer) {
  <cap-rubrik [isClosable]="false" [isOpen]="true">
    <ng-container title>
      <h3>{{ "grundstueck.rubrik.HaengigeGeschaefte" | translate }}</h3>
    </ng-container>
    @if (grundstueckEntry) {
      <cap-grundstueck-haengige-icp [grundstueckId]="gsId" [hasRight]="isEigentuemer"></cap-grundstueck-haengige-icp>
    }
  </cap-rubrik>
}
